export default __webpack_public_path__ + "static/media/html.4ccbc580.png";